<template>
  <div class="thankyou-container">
    <div class="w100">
      <wrap-container class="thankyou-inner-container">
        <wrap-container class="cascade w50">
          <img
            src="@/assets/img/1x/transactions-accounts-transfer-ok.svg"
            width="150px"
            alt="Imagen Icono Tarjeta Tilde Verde"
          />
          <p class="title">
            ¡Listo <span data-obfuscate>{{ this.nombre }}</span
            >!
          </p>
          <p class="subtitle">Ya tenés tu caja de ahorro en BBVA</p>
        </wrap-container>
        <wrap-container>
          <p class="title">Tu tarjeta está en camino</p>
          <p class="subtitle">
            Te vamos a enviar tu tarjeta de débito dentro de los próximos 10
            días hábiles. La puede recibir cualquier persona mayor de 14 años.
            Llegará a <span data-obfuscate>{{ this.domicilio }}</span
            >..
          </p>
        </wrap-container>
        <wrap-container>
          <p class="title">Próximo paso: <br />Esperá nuestro llamado</p>
          <p class="subtitle">
            En las próximas 72 horas, te vamos a llamar para ayudarte a
            contratar los productos para emprendedores.
          </p>
        </wrap-container>
        <wrap-container class="openpay" style="padding: 10%">
          <div class="title-openpay">
            <img
              src="@/assets/img/1x/extraordinary_contribution.svg"
              class="box_img"
              alt="Imagen Icono Mano Billetes"
            />
            <br />Abrí posibilidades infinitas con Openpay
          </div>
          <wrap-container class="openpay-benefits">
            <img
              src="@/assets/img/1x/computer_front_end.svg"
              class="box_img"
              alt="Imagen Icono Portatil"
            />
            <p class="box_text">Aceptar las principales tarjetas</p>
            <img
              src="@/assets/img/1x/digital_payment_device_dollar.svg"
              class="box_img"
              alt="Imagen Icono Movil Con Dolar"
            />
            <p class="box_text">Cobrar con QR y otros métodos de pago</p>
            <img
              src="@/assets/img/1x/AR-Openpay-GO-UX-V02.svg"
              class="box_img"
              alt="Imagen Icono Card"
            />
            <p class="box_text">Seguir tus ventas</p>
          </wrap-container>
        </wrap-container>
        <wrap-container class="openpay-footer">
          <wrap-container style="text-align: center">
            <img
              src="@/assets/img/1x/openpay.svg"
              class="box_img"
              alt="Imagen Icono Open Way"
            />
          </wrap-container>
        </wrap-container>
      </wrap-container>
    </div>
  </div>
</template>

<script>
import thankyouPage from "@/mixins/thankyou-page";
import WrapContainer from "@/components/core/Container";
import { ON_GA4_PARAMS } from "@/config/constants/mutation-types";

export default {
  name: "GraciasEmprendedores",
  mixins: [thankyouPage],
  components: {
    WrapContainer
  },
  data() {
    return {
      color: "#1973b8",
      nombre: this.$store.getters.getDatosPersonales().nombre
    };
  },
  props: {},
  mounted() {
    this.ga4AppCompleted("8 success", "contratacion");
    this.$store.commit(ON_GA4_PARAMS, {
      level3: "solicitud de tarjeta",
      level4: "8 success"
    });
  }
};
</script>

<style scoped>
div.thankyou-container {
  color: white;
  text-align: left;
  background: #003165;
  padding: 30px;
}

p.titulo-detalle {
  font-size: 20px;
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
}

p.incluye,
p.crea {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  text-align: start;
}
p.incluye {
  font-size: 18px;
}
p.crea {
  font-size: 20px;
  margin-bottom: auto;
}

.title {
  font-size: 26px;
  font-weight: bold;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}
.title-openpay {
  font-size: 26px;
  font-weight: bold;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  text-align: center;
}
.box_item {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  height: 80px;
  padding: 16px 0px 40px 0px;
  border-radius: 1px;
  background-color: #003165;
  color: #ffffff;
}
.box_img {
  grid-column: 1;
}
.box_text {
  grid-column: 2;
}
.box_image_text {
  margin-left: 12px;
}
.box_text_item {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #ffffff;
  margin: 0px;
  padding-left: 16px;
}
.box_item_help {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  height: 80px;
  padding: 16px 0px 40px 0px;
  border-radius: 1px;
  background-color: #003165;
  color: #ffffff;
}
.box_img_help {
  grid-column: 1;
  grid-row: 1;
}
.box_text_help {
  grid-column: 2;
  grid-row: 1;
  width: 280px;
  height: 62px;
}
.box_text_item_help {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #ffffff;
  margin: 0px;
}
.img_help {
  width: 16px;
  height: 16px;
}
.button {
  margin: 5% 30% 10% 30%;
}
.button_banelco {
  margin: 5% 20% 10% 20%;
}

@media screen and (min-width: 600px) {
  .thankyou-inner-container {
    display: flex;
  }
  .w50:first-child {
    padding-right: 20px;
  }
  .w50:last-child {
    padding-left: 20px;
    padding-right: 50px; /* Evitar ser tapado por flotante ayuda */
  }
  .titulo-detalle {
    margin-top: 0;
  }
}
div.box_image_links {
  display: flex;
}
.box_image_links img {
  margin-top: 22px;
}
.detalle {
  font-size: 17px;
  line-height: 24px;
  margin-bottom: 35px;
}
.box_img_link {
  color: #57b7f8;
  font-size: 16px;
  line-height: 1.6;
}
.subtitle {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #ffffff;
}

.subtitleinfo {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #ffffff;
  margin-bottom: 0px;
}

.subtitledirection {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #ffffff;
  margin-top: 0px;
}
.ingresa {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 17px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #ffffff;
}
.openpay {
  background-image: linear-gradient(to bottom, #ffffff, #d4edfc);
  color: black;
}
.openpay-benefits {
  display: grid;
}
.openpay-footer {
  background-color: #004481;
  align-items: center;
}
</style>
